"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgClownFaceFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 22a8 8 0 007.744-10.016A2 2 0 1020 8a2 2 0 10-2-2 2 2 0 10-3.984.256A8.013 8.013 0 0012 6c-.697 0-1.372.089-2.016.256A2 2 0 106 6a2 2 0 10-2 2 2 2 0 10.256 3.984A8 8 0 0012 22zm2-6a2 2 0 11-4 0 2 2 0 014 0zm-4-3l-1-2-1 2 1 2 1-2zm5-2l1 2-1 2-1-2 1-2zm-6.008 6.115a.417.417 0 10-.65.52c1.833 2.293 5.483 2.293 7.317 0a.417.417 0 10-.651-.52c-1.5 1.875-4.516 1.875-6.016 0z' }))); };
exports.default = SvgClownFaceFilled;
//# sourceMappingURL=ClownFaceFilled.js.map